export class Usuario {
    IDUsuario: number;
    Email: string;
    Contrasena: string;
    Tipo: number;

}
